module.exports = __webpack_public_path__ + "static/media/bruce4.307b0dde.mp3";